export default __webpack_public_path__ + "static/media/data4.a134802e.jpeg";